$easyreels_i18n_switch $mol_switch
	options *
		ru \RU
		en \EN
